import { render, staticRenderFns } from "./MainBackButton.vue?vue&type=template&id=1d3c0ebb&scoped=true&"
import script from "./MainBackButton.vue?vue&type=script&lang=js&"
export * from "./MainBackButton.vue?vue&type=script&lang=js&"
import style0 from "./MainBackButton.vue?vue&type=style&index=0&id=1d3c0ebb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3c0ebb",
  null
  
)

/* custom blocks */
import block0 from "./MainBackButton.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports